<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card>
        <tt-tabs [(ttSelectedId)]="setting.gb_customerbuscos" (ttSelectedIdChange)="onTabChanged()">
            <tt-tab ttId="USED" ttLabel="gb_customerbuscos_used"></tt-tab>
            <tt-tab ttId="ALL" ttLabel="gb_customerbuscos_all"></tt-tab>
        </tt-tabs>
    </tt-card>

    <tt-list [ttData]="itemsListCustomerCompanies"></tt-list>
</tt-page>
